import React from "react";
import AdminDisabledField from "features/Admin/components/AdminDisabledField";

const PatientForm = ({ values }) => (
	<div>
		<AdminDisabledField title="Délai de rendu des résultats (en heures)" value={values.time_to_results} />
		<AdminDisabledField title="Note pour le patient" value={values.note_for_patient} />
		<AdminDisabledField title="Résultats pour le prescripteur uniquement" value={values.results_prescriber_only} />
	</div>
);

export default PatientForm;
